class BlogView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el
    this.$root.find('.blog__aside-filter-item').click(this.handleSelectChange.bind(this))
  }

  handleSelectChange(event) {
    window.location.href = $(event.currentTarget).data('link')
  }
}

document.addEventListener('DOMContentLoaded', function () {
  return new BlogView($('.blog-view'))
})
